<cp-popup [width]="dialogWidth" [height]="dialogHeight"  (close)="onCancel.emit()" [labelPlain]="dialogTitle"  [contentPadding]="false" [disposable]="false">
	<div class="main-container">

		<div class="top-panel">
			<div class="search-box-container" *ngIf="searchEnabled">
				<cp-search-box-widget #searchBox (search)="onSearchChanged($event)" [debounce]="200"></cp-search-box-widget>
			</div>
			<div class="header-message-container" *ngIf="headerMessageTranslationKey">
				<span>{{headerMessageTranslationKey | cpLabelTranslate}}</span>
			</div>
		</div>

		<div class="available-items-container">
			<div  class="available-items-label">
				{{this.availableItemsTranslationKey | cpLabelTranslate : {'a0':  (filteredUnselectedDataItems && filteredUnselectedDataItems.total) ?  filteredUnselectedDataItems.total : 0} }}
			</div>
			<div class="loading-spinner" *ngIf="isDataLoading"></div>
			<kendo-grid   #availableItemsGrid
					[height]="gridHeight"
					[rowHeight]="gridRowHeight"
					[data]="filteredUnselectedDataItems"
					[pageSize]="pageSize"
				  	[resizable]="true"
					[scrollable]="'virtual'"
					[sortable]="availableItemsGridSortSettings"
					[sort]="availableItemsGridState.sort"
					[skip]="availableItemsSkip"
					(cellClick)="onAvailableItemsCellClick($event)"
					(sortChange)="onAvailableItemsSortChanged($event)">
				<kendo-grid-column
						*ngFor="let column of gridColumns"
						[field]="column.columnName"
						[title]="column.columnCaption"
						[width]="column.columnWidth">
					<ng-template kendoGridCellTemplate let-dataItem  let-columnIndex="columnIndex">
						<div [ngClass]="{'last-column': columnIndex === (gridColumns.length - 1)}">
							<span [innerHTML]="dataItem[column.columnName]| cpMarkPure:this.searchTerm ?? '':markOperator.Contains">
							</span>
							<i class="cp-icon-procedure_add"></i>
						</div>
					</ng-template>
				</kendo-grid-column>
			</kendo-grid>
			<div class="select-all-container" *ngIf="!isDataLoading"  (click)="addAllItems()"  [ngClass]="{'disabled': !addAllItemsEnabled}" >
				<i class="cp-icon-add_all"></i>
				<span>{{'MultiselectGridAddAll' | cpLabelTranslate }}</span>
			</div>
		</div>
		<div class="selected-items-container">
			<div class="selected-items-label">
				{{this.selectedItemsTranslationKey | cpLabelTranslate : {'a0': selectedDataItems.length} }}
			</div>
			<kendo-grid #selectedItemsGrid
				[height]="gridHeight"
				[resizable]="true"
				(cellClick)="onSelectedItemsCellClick($event)"
				[data]="selectedDataItems">
				<kendo-grid-column
						*ngFor="let column of gridColumns"
						[field]="column.columnName"
						[title]="column.columnCaption"
						[width]="column.columnWidth">
					<ng-template kendoGridCellTemplate let-dataItem  let-columnIndex="columnIndex">
						<div [ngClass]="{'last-column': columnIndex === (gridColumns.length - 1)}">
							<span>{{dataItem[column.columnName]}}</span>
							<i class="cp-icon-procedure_delete"></i>
						</div>
					</ng-template>
				</kendo-grid-column>
			</kendo-grid>
			<div class="remove-all-container"  (click)="removeAllItems()" [ngClass]="{'disabled': !removeAllItemsEnabled}">
				<i class="cp-icon-remove-all" ></i>
				<span>{{'MultiselectGridRemoveAll' | cpLabelTranslate }}</span>
			</div>
		</div>
	</div>
	<cp-popup-buttons-ok-cancel class="popup-buttons"
									[okDisabled]="!isValidDataForSubmit()"
									[cancelLabel]="'Cancel'"
									(cancel)="onCancel.emit()"
									[okLabel]="'Done'"
									(ok)="onEditorDone()">
	</cp-popup-buttons-ok-cancel>
</cp-popup>
